import { useEffect, useState } from "react";
import useApi from "./useApi";

interface SapConfigSummary {
  id: number;
  sapUrl: string;
  companyDb?: string;
  product: string;
  enabled: boolean;
}

export default function useSapConfigs() {
  const [items, setItems] = useState<SapConfigSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    api.messaging.get("Sap/config")
      .then((r) => r.json())
      .then((data) => {
        if (data && data.id) setItems([data]);
        else setItems([]);
      })
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [api.messaging]); // eslint-disable-line react-hooks/exhaustive-deps

  return { items, loading };
}
